import './LogoHeader.scss'

const LogoHeader = () => {
    return (
        <img
            src={'images/logo/logo-blue.svg'}
            alt="CineStar"
            role="button"
            onClick={() => (location.href = `${process.env.REACT_APP_WEB_PORTAL_URL}`)}
            className="logo-header my-auto"
        />
    )
}

export default LogoHeader
